/**
 * Icone de um lapis com uma linha que possui
 * uma bolinha em cada ponta
 * Usado para abrir o menu com as possiveis 
 * figuras que podem ser usadas no mapa
 */
export const PenIcon = (props) => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.06042 12.2129L4.63598 20.4547L10.3022 19.9396"
      stroke={props.stroke || 'currentColor'}
    />
    <path
      d="M15.9961 1.39784C14.7475 1.10983 13.6201 1.38323 13.4757 2.00805L13.2164 3.1374L17.7356 4.17753L17.9963 3.04786C18.1394 2.42336 17.2449 1.68463 15.9961 1.39784Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M11.8351 19.4773L14.8756 16.6075L10.3551 15.5671L11.8351 19.4773Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M10.6156 14.4369L15.1348 15.4771L17.4755 5.30704L12.9563 4.26693L10.6156 14.4369Z"
      fill={props.fill || 'currentColor'}
    />
    <circle
      cx="1.80289"
      cy="11.9552"
      r="1.80289"
      fill={props.fill || 'currentColor'}
    />
    <circle
      cx="4.89359"
      cy="20.1969"
      r="1.80289"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);

/**
 * Icone de ponto marker
 * usado para marcar pontos no mapa
 */
export const MarkerIcon = (props) => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.1669 6.35556C9.73356 3.78889 13.8891 3.78889 16.4558 6.35556C17.678 7.57778 18.3624 9.19111 18.3747 10.9144C18.3991 12.6256 17.7513 14.2511 16.578 15.4978L11.7991 20.2767L7.11801 15.5956C4.60023 13.0289 4.62467 8.89778 7.1669 6.35556ZM6.31134 5.5C3.29245 8.51889 3.26801 13.4078 6.26245 16.4511L11.8113 22L17.458 16.3533C20.3424 13.2978 20.2936 8.48222 17.3113 5.5C14.268 2.45667 9.35467 2.45667 6.31134 5.5Z"
      fill={props.fill || 'currentColor'}
    />
    <circle cx="11.8113" cy="11" r="2.75" fill={props.fill || 'currentColor'} />
  </svg>
);

/**
 * Icone de linha
 * usado para fazer linhas no mapa
 */
export const LineIcon = (props) => (
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="2.61134" cy="1.8" r="1.8" fill={props.fill || 'currentColor'} />
    <circle
      cx="11.6113"
      cy="14.8"
      r="1.8"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M2.31134 1.5L10.8113 13.5"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="1.5"
    />
  </svg>
);

/**
 * Icone de poligono
 * usado para fazer poligonos no mapa
 */
export const PolygonIcon = (props) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="2.31154"
      cy="9.49971"
      r="1.8"
      fill={props.fill || 'currentColor'}
    />
    <circle
      cx="8.31147"
      cy="16.4997"
      r="1.8"
      fill={props.fill || 'currentColor'}
    />
    <circle
      cx="16.3114"
      cy="11.2995"
      r="1.8"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M8.31146 16.5L2.31146 9.5L7.31146 2.5L16.3115 11.5L8.31146 16.5Z"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="1.5"
    />
    <circle
      cx="7.30793"
      cy="2.49971"
      r="1.8"
      fill={props.fill || 'currentColor'}
    />
    <circle
      cx="7.30796"
      cy="2.49912"
      r="0.9"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);

/**
 * Icone de circulo(raio)
 * usado para raios no mapa
 */
export const ElipseIcon = (props) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="8.81134"
      cy="8"
      r="7.25"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="1.5"
    />
  </svg>
);

/**
 * Icone de lixeira
 * usado para excluir desenhos feitos
 */
export const TrashIcon = (props) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.94025 1.64773H4.31525V1.27273C4.31525 0.776926 4.71718 0.375 5.21298 0.375H7.75843C8.25424 0.375 8.65616 0.776926 8.65616 1.27273V1.64773H9.03116H12.213C12.3573 1.64773 12.4743 1.76474 12.4743 1.90909V3.18182C12.4743 3.32617 12.3573 3.44318 12.213 3.44318H11.5766H11.2016V3.81818V12.7273C11.2016 13.2231 10.7997 13.625 10.3039 13.625H2.66752C2.17172 13.625 1.7698 13.2231 1.7698 12.7273V3.81818V3.44318H1.3948H0.758434C0.614087 3.44318 0.49707 3.32617 0.49707 3.18182V1.90909C0.49707 1.76474 0.614087 1.64773 0.758434 1.64773H3.94025ZM4.57662 4.71591C4.01805 4.71591 3.56525 5.16871 3.56525 5.72727V10.8182C3.56525 11.3767 4.01806 11.8295 4.57662 11.8295C5.13518 11.8295 5.58798 11.3767 5.58798 10.8182V5.72727C5.58798 5.16871 5.13518 4.71591 4.57662 4.71591ZM8.3948 4.71591C7.83624 4.71591 7.38343 5.16871 7.38343 5.72727V10.8182C7.38343 11.3767 7.83624 11.8295 8.3948 11.8295C8.95336 11.8295 9.40616 11.3767 9.40616 10.8182V5.72727C9.40616 5.16871 8.95336 4.71591 8.3948 4.71591Z"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="0.75"
    />
  </svg>
);

/**
 * Icone de confirmação(check)
 * usado para salvar os desenhos feitos
 */
export const CheckIcon = (props) => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.23235 13.7998C5.91317 13.7998 5.60601 13.6733 5.37926 13.4466L0.554485 8.62179C0.0834008 8.15042 0.0834008 7.38697 0.554485 6.91589C1.02585 6.4448 1.7893 6.4448 2.26039 6.91589L6.1617 10.8172L14.341 1.22322C14.7733 0.716954 15.5342 0.6558 16.0416 1.08779C16.5485 1.52006 16.609 2.28156 16.1771 2.78839L7.15022 13.3759C6.93185 13.632 6.61659 13.7853 6.2801 13.7987C6.26418 13.7992 6.24827 13.7998 6.23235 13.7998Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);
